
import { DataGrid } from "components/DataGrid/DataGrid";
import { DynamicComponentHOC } from "components/DynamicComponentHOC/DynamicComponentHOC";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { ToolbarInTab } from "components/ToolbarInTab/ToolbarInTab";
import { Attachment } from "pages/OfficeAutomation/Cartable/components/ActionList/components/Attachment/Attachment";
import { useContext, useEffect, useState } from "react";
import { JobStatus, MessageType } from "types/enum";
import { DynamicForm } from "types/types";
import { GUID_EMPTY } from "utils/constants";
import { DYNAMICFORMS } from "utils/dynamicForms";
import { ENDPOINTS } from "utils/endpoints";
import { downloadCSV, getGridSetting, getPageSize, trans } from "utils/helpers";
import { CustomerFeedBackForm } from "../CustomerFeedBack/CustomerFeedBack";
import { cancelRequest, GetHelpText, getMyOwnRequests, getRequesterUserId, getStartForm } from "./api";
import { RequestDetails } from "./components/RequestDetails";
import { RequestView } from "./components/RequestView";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useLocation } from "react-router-dom";
import { getEnv } from "config/runtimeEnv";
import { MoveTemp } from "pages/OfficeAutomation/Cartable/components/ActionList/components/Attachment/api/api";
import { TabBar } from "components/Tabbar/Tabbar";
interface MyOwnRequestsListProp{
    curentTab?:string;
    Type?:any;
    tabName?:string;
  }

export const MyOwnRequestsList = ({curentTab, Type ,tabName}:MyOwnRequestsListProp) => {

    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [response, setResponse] = useState<any>([]);
    const [selectedObj, setSelectedObj] = useState< any>(null);
    const[showAttachmentByDynamicForm,setShowAttachmentByDynamicForm]=useState<any>(false);
    const [showForm, setShowForm] = useState(false);
    const [showViewForm, setShowViewForm] = useState(false);
    const [showCustomerFeedBackForm, setShowCustomerFeedBackForm] = useState(false);
    const [mode, setMode] = useState("");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [modalFormLabel,setModalFormLabel]=useState<any>('')
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
    const [jobstatusFilter, setJobstatusFilter] = useState<any>(0);
    const [orderBy, setOrderBy] = useState<any>([]);
    const [search, setSearch] = useState(null);
    const [filterlist, setFilterlist] = useState<any>("");
    const [dynamicForm, setDynamicForm] = useState<DynamicForm | any>("GeneralRequestForm");
    const [showDynamicForm, setShowDynamicForm] = useState<boolean>(false);
    const [showAttachment, setShowAttachment] = useState(false);
    const [refrenceId,setRefrenceId]=useState<any>(null)
    const [pages, setPages] = useState<number>(0);
    const lang = localStorage.getItem("DefaultLanguage");
    const layoutContext = useContext(LayoutContext);
    const [helpMessage,setHelpMessage]=useState<any>(null)
    const [Updated, setUpdated] = useState<any>(true);
    const location=useLocation()
    const [filterAndSort, setFilterAndSort] = useState<any>(null);
    const [OriginalOwnerId,setOriginalOwnerId]=useState<any>(null)
const [temporaryOwnerId,setTemporaryOwnerId]=useState<any>(null)
   const [curentTabWithAttachment, setCurentTabWithAttachment] = useState<any>("request")


  const tabChangeHandle = (tab) => {
        setCurentTabWithAttachment(tab)
    } 


    let customFuction: any = [
        [(e) => { setShowCustomerFeedBackForm(true); setSelectedObj(e) }, "clipboard", "FeedBack", "JobStatusEnum" , JobStatus.FinishedAndWaitingForEvaluatio],
        [(e) => { chatWithFollowupResponsible(e) }, "paper-plane", "Chat"]
    ]
    if((Type==2||Type==null))customFuction.push([(e) => { Toast(trans("Msg_CancelConfirm"), MessageType.confirm, handleCancelRequest) }, "xmark", "cancellation"])
    async function chatWithFollowupResponsible(e) {
        try {
            const res = await getRequesterUserId(e.Id);
            if(res?.Data.Id && res?.Data.Id != GUID_EMPTY){
            let item = {
                Id: res?.Data.Id,
                name: res?.Data.Description
            }
            localStorage.setItem("JobRequester", JSON.stringify(item));
            window.open(`#/message`)
          }
        } catch (error) {

        }
    }



    useEffect(()=>{
        setCurentTabWithAttachment("request")
    },[DYNAMICFORMS[dynamicForm?.Name],showAttachmentByDynamicForm])



let tabContentWithAttachment = [

        { title: "request" ,body: (<>
             

             <DynamicComponentHOC
     callAttachmentMoveTemp={(e)=>{
            setOriginalOwnerId(e)
          }}
          setShowAttachmentByDynamicForm={setShowAttachmentByDynamicForm}//شده و تب پیوست را نمایش میدهد و این پراپز کال بک است true داینامیک فرم اگر شامل کامپوننت پیوست باشد مقدار استیت 

    parentISCartable={true}
    modalFormLabelCallBack={(e)=>setModalFormLabel(e)}
    onHide={() => { setShowDynamicForm(false); setForceUpdate(!forceUpdate) }} 
    componentName={DYNAMICFORMS[dynamicForm.Name] ?null:dynamicForm.Name} component={DYNAMICFORMS[dynamicForm.Name] ?DYNAMICFORMS[dynamicForm.Name].component:null}
    reload={() => { setForceUpdate(!forceUpdate) }} componentParams={dynamicForm.Parameters} processId={dynamicForm?.ProjectId  }
    handleCancelForm={() => setShowDynamicForm(false)} referenceId={undefined} />
            </>), },

...(
//تعیین شده بود که تب پیوست نمایش داده باشه یا اینکه کلا داینامیک فرم showAttachmentByDynamicForm شرط نمایش: اگر داینامیک فرم بود و داخل داینامیک فرم با استیت
(!DYNAMICFORMS[dynamicForm?.Name] && showAttachmentByDynamicForm) || DYNAMICFORMS[dynamicForm?.Name] ? [
          { title: "attachment" ,body: (<>
               <Attachment       
                temporaryOwnerIdCallBack={(e)=>setTemporaryOwnerId(e)}
            curentTabWithAttachment={curentTabWithAttachment}
                onHide={() => { setShowAttachment(false);setRefrenceId(null)  }} mood={mode} endpoint={ENDPOINTS.clientPortal.clientPortal.attachment} ownerId={mode=='create'?null:selectedObj?.Id} />
            </>
            ), },
] : [])




    ];

    const searchHandler = (str) => {
        setPageNum(1);
        if (str == "") {
            setSearch(null)
            getMyOwnRequestsAsync(1, null)
        } else {
            setSearch(str)
            getMyOwnRequestsAsync(1 , str)
        }
    }
    const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize(`MyOwnRequestsList-${tabName}`, e.currentTarget.value)
        getMyOwnRequestsAsync(1)
    };
    const handleGoPage = (value) => {
        if (value) {
            if (value < 1 || value > pages) { }
            else {setPageNum(+value);getMyOwnRequestsAsync(+value)}
        } 
    };
    const handleNextPage = () => {
        if(pageNum < pages){
            setPageNum(pageNum + 1);
            getMyOwnRequestsAsync(pageNum + 1);
        };
    };
    const handlePrevPage = () => {
        if(pageNum > 1){
            setPageNum((pageNum)=>{return +pageNum - 1});
            getMyOwnRequestsAsync(pageNum - 1);
        };
    };

    const selectedObjCallback = (obj) => {
        setSelectedObj(obj);
    }

    const handleCreateRequest = (obj) => {
        setMode("create");
        getStartFormAsync(obj.Id);
    }

    async function getStartFormAsync(id: string) {
        document.body.classList.add("loading-indicator-"+lang);
        try {
            setMode("create");
            const res = await getStartForm(id);
            if (res.Data){
                setDynamicForm(res.Data);
                setShowDynamicForm(true);
            }
            else{
                setDynamicForm(undefined);
                setShowDynamicForm(false) 
            } 
        } catch (error) {
            setDynamicForm(undefined)
            setShowDynamicForm(false)
        }
        document.body.classList.remove("loading-indicator-"+lang);  
      }
    const handleCancelRequest = async (id) => {
        try {
            await cancelRequest(selectedObj?.Id)
            setForceUpdate(!forceUpdate)
        } catch (error) {
        }
    }
    const handleViewRow = () => {
        setMode("view");
        setShowViewForm(true)
    }
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel": downloadCSV(response ,4 ,trans("MyOwnRequestsList")); break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "cancellation": if (selectedObj)
                //  Toast(trans("Msg_CancelConfirm"), "warning", "alert", handleCancelRequest)
            Toast(trans("Msg_CancelConfirm"), MessageType.confirm, handleCancelRequest)

            ; break;
            case "view": if (selectedObj) handleViewRow(); break;
            case "action": if (selectedObj){ setMode("view");setShowForm(true);} break;
            case "help": alert("call api help"); break;
            case "attach": if (selectedObj) {
                setMode("edit")
                setShowAttachment(true)
            } else {
                // Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning)

            } break;
        }
    };

    async function getMyOwnRequestsAsync(pagNum = pageNum ,searchSTR=search) {
        setLoading(false)

        let pageSizeChangedByUser = getPageSize(`MyOwnRequestsList-${tabName}`)
        setPageSize(pageSizeChangedByUser)
        try {
            const res = await getMyOwnRequests(pagNum, pageSizeChangedByUser, searchSTR, filterAndSort?.OrderFormat?.join(","), filterAndSort?.Filterlist, Type)
            setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) ;
            setUpdated(!Updated)
            if (res.Data.Data.length > 0) {
                setResponse(res.Data)
            }
        } catch (error) {

        }
        setLoading(true)

    }


      async function getHelpTextAsync() {
        try {
            const res = await GetHelpText('myownrequests')
                 setHelpMessage(res.Data)

         
        } catch (error) {

        }
    }


    useEffect(() => {
        //getDataAsync();setResponse
          if(tabName==curentTab && filterAndSort!=null){

              setSelectedObj(null)
              setResponse([])
              getMyOwnRequestsAsync();
            }
    }, [ jobstatusFilter,filterAndSort,forceUpdate]);
    // useEffect(() => {
    //     //getDataAsync();setResponse
    //       if(tabName==curentTab){
    //           setResponse([])
    //           getMyOwnRequestsAsync();
    //         }
    // }, [ forceUpdate]);

    // useEffect(() => {
    //     if(tabName==curentTab){
    //         let settings = getGridSetting("MyOwnRequestsList")
    //         setOrderBy(settings[1])
    //         setFilterlist(settings[0])
    //     }
    // }, [curentTab ,tabName]);


        useEffect(() => {
            if(tabName==curentTab){
        let settings = getGridSetting(`MyOwnRequestsList-${tabName}`)
        setFilterAndSort({ Filterlist: settings[0], OrderFormat: settings[1] })
            }
    }, [curentTab ,tabName]);

useEffect(()=>{
  getHelpTextAsync()
    
},[])



useEffect(()=>{
    if(OriginalOwnerId && temporaryOwnerId){
        //کردن MoveTemp  رو از ریسپانس ذخیره فرم میگیریم و حالا هم اونرآیدی اصلی رو داریم و هم موقت پس درخواست میزنیم برای MoveTempOwnerIdبعد از اینکه فرم ذخیره شد 
                 const MoveTempAsyn=async()=>{
                    try{
                        const res = await MoveTemp({tempOwnerId:temporaryOwnerId,ownerId:OriginalOwnerId} ,ENDPOINTS.clientPortal.clientPortal.attachment  ,null);
                    }catch{}
                 }

            MoveTempAsyn()
    }
},[OriginalOwnerId])

    return (
        <>
        {tabName==curentTab&&
        <>
        
        <ToolbarInTab Updated={Updated} RefreshWithNotif={true} action={selectedObj?.PerformerPositionId	==layoutContext.currentUserPosition.PositionId }  cancellation={Type==2||Type==null} defultSerach={search} attach={true} handleSearch={searchHandler} handleSelectedMyOwnRequestStartForm={(Type==2||Type==null)?handleCreateRequest:undefined}  id={selectedObj} emptyList={response?.TotalRecords == 0} search={true} handleClickToolbar={clickToolbarCallback} />
        <div style={{overflowY: "auto",
             height: "74vh",
            scrollbarWidth: "thin",}} className="col-lg-12 mt-0">
            {loading ?
                <>{
                    (response?.Data?.length > 0 ?
                        <div className="card">
                            <div className="card-body p-0">
                                <>
                                    <DataGrid
                                        DoubleClick={(obj) => { 
                                            if((obj.JobStatusEnum==JobStatus.UnderReview || obj.JobStatusEnum==JobStatus.InProgress|| obj.JobStatusEnum==JobStatus.FinishedAndWaitingForEvaluatio ) && obj.PerformerPositionId==layoutContext.currentUserPosition.PositionId){
                                                clickToolbarCallback("action")
                                            }else{
                                                clickToolbarCallback("view")
                                            }  
                                            setSelectedObj(obj);  }}
                                        View={true}
                                        ViewParametr={"NotSeen"}
                                        customFuction={customFuction}
                                         handlefiltering={(str:any) => {str.Filterlist != undefined  ? setFilterAndSort(str) : setFilterAndSort({...filterAndSort, Filterlist:str})}}
                                        filterStr={filterAndSort.Filterlist}
                                        orderFormatList={filterAndSort.OrderFormat}
                                        orderFormat={(order) => { setFilterAndSort({ ...filterAndSort, OrderFormat: order }) }}
                                        parentName={`MyOwnRequestsList-${tabName}`}
                                        theadData={Object.keys(response.Data[0])}
                                        tbodyData={response.Data}
                                        minCellWidth={80}
                                        rowSelected={selectedObj}
                                        handleAttachment={(e) => { setSelectedObj({ Id: e }); setMode("edit"); setShowAttachment(true) }}
                                        selectedRowObjectCallback={selectedObjCallback}
                                        startIndex={7}
                                        handleView={handleViewRow}
                                        totalRecords={response.TotalRecords}
                                        pageNum={pageNum}
                                        pageSize={pageSize}
                                        HandleNextPage={handleNextPage}
                                        HandlePrevPage={handlePrevPage}
                                        handlechangePageSize={handleChangePageSize}
                                        first={() =>{getMyOwnRequestsAsync(pages) ;setPageNum(pages)}}
                                        end={() => {getMyOwnRequestsAsync(1) ;setPageNum(1)}}
                                        handleGoPage={handleGoPage}
                                    />
                                </>
                            </div>
                        </div>
                        : <Message message={"NoDataForPreview"} type={messageType} />
                    )

                }
                  { helpMessage ? <Message message={helpMessage} type={"instruction"} />:<></>}
                    <Message message={trans("Help_DoubleClickPendingActions")} type={"info"} />
                   
                  { getEnv("REACT_APP_TADBIR_OWNER") && <Message message={trans("Help_ClientPortal_Default_1")} type={"info"} />}
                    <Message message={trans("Help_ClientPortal_Default_2")} type={"info"} />

                </>
                : <Loading />
            }

        </div>
        {showAttachment &&
            <ModalForm mode={mode} title={("Attachment")} onHide={() => { setRefrenceId(null);setShowAttachment(false) }} show={showAttachment}>
                <Attachment onHide={() => { setShowAttachment(false);setRefrenceId(null)  }} mood={mode} endpoint={ENDPOINTS.clientPortal.clientPortal.attachment} ownerId={selectedObj?.Id} />
            </ModalForm>
        }
        {showDynamicForm &&
            <ModalForm modalHeight={63} mode={mode}
            modalProfileKey={dynamicForm?.Name} 
            title={
                        !DYNAMICFORMS[dynamicForm?.Name] ?modalFormLabel:(dynamicForm?.Name)}
            
          onHide={() => { setShowDynamicForm(false);  }} show={showDynamicForm}>
                <>
                {dynamicForm?.Name!="OrderForm"&&
                    <div className="" >
                        <Message message={trans("Help_ClientPortal_Default_1")} type={"info"} />
                        <Message message={trans("Help_ClientPortal_Default_2")} type={"info"} />
                        {dynamicForm?.Name=="CustomerGeneralRequestForm"&&
                        <Message message={trans("Help_ClientPortal_Default_3")} type={"info"} />
                        
                        }
                    </div>
                }
           


{
    (!DYNAMICFORMS[dynamicForm?.Name] && showAttachmentByDynamicForm) || DYNAMICFORMS[dynamicForm?.Name]?
      <TabBar  tabChange={tabChangeHandle} content={tabContentWithAttachment} curentTab={curentTabWithAttachment} defaultTab={"request"} />
    :
 <DynamicComponentHOC
     callAttachmentMoveTemp={(e)=>{
            setOriginalOwnerId(e)
          }}
          setShowAttachmentByDynamicForm={setShowAttachmentByDynamicForm}//شده و تب پیوست را نمایش میدهد و این پراپز کال بک است true داینامیک فرم اگر شامل کامپوننت پیوست باشد مقدار استیت 

    parentISCartable={true}
    modalFormLabelCallBack={(e)=>setModalFormLabel(e)}
    onHide={() => { setShowDynamicForm(false); setForceUpdate(!forceUpdate) }} 
    componentName={DYNAMICFORMS[dynamicForm.Name] ?null:dynamicForm.Name} component={DYNAMICFORMS[dynamicForm.Name] ?DYNAMICFORMS[dynamicForm.Name].component:null}
    reload={() => { setForceUpdate(!forceUpdate) }} componentParams={dynamicForm.Parameters} processId={dynamicForm?.ProjectId  }
    handleCancelForm={() => setShowDynamicForm(false)} referenceId={undefined} />
}

                </>
            </ModalForm>
        }

        {showForm &&
            <ModalForm modalHeight={50} mode={mode} title="Details" onHide={() => {setShowForm(false);setForceUpdate(!forceUpdate)}} show={showForm}>
                <RequestDetails referenceId={selectedObj?.ReferenceId} Id={selectedObj?.SourceId} JobNo={selectedObj?.JobNo} hide={() => { setShowForm(false) ;setForceUpdate(!forceUpdate)}}  jobId={selectedObj?.Id} processId={selectedObj?.PRJ_UID} mode={mode} />
         </ModalForm>
        }
        {showViewForm &&
            <ModalForm modalHeight={50} mode={mode} title="view" onHide={() => {setShowViewForm(false);setForceUpdate(!forceUpdate)}} show={showViewForm}>
                <RequestView Id={selectedObj?.SourceId} JobNo={selectedObj?.JobNo} hide={() => { setShowViewForm(false) ;setForceUpdate(!forceUpdate)}}  jobId={selectedObj?.Id} processId={selectedObj?.PRJ_UID} mode={mode} />
         </ModalForm>
        }
        {showCustomerFeedBackForm &&
            <ModalForm modalHeight={50} mode={mode} title="CustomerFeedBack" onHide={() => setShowCustomerFeedBackForm(false)} show={showCustomerFeedBackForm} >
                <CustomerFeedBackForm reload={() => { setForceUpdate(!forceUpdate) }} hide={() => { setShowCustomerFeedBackForm(false) }} Id={selectedObj?.Id} mode={"edit"} />
            </ModalForm>
        }
        
        </>
        }
        
        </>

    );
}